import { HomeContainer } from './containers'

// Sync route definition
export default {
  component: HomeContainer,
}
